import { type CountryCode } from '@constants'
import { createRequestHelper } from '@utils/swr'
import { type EcCartRequestCacheResponse } from '../types/apiResponse'
import { type ECommerceV2Apis } from '../types/apis'

const {
  useRequest,
} = createRequestHelper<ECommerceV2Apis['get']['cartRequestCache'], EcCartRequestCacheResponse, { shouldRequest: boolean, country_code: CountryCode }>({
  client: 'eCommerceV2',
  key: params => params?.shouldRequest ? `/${params.country_code}/cart/cart_request_cache` : null,
  isImmutable: true,
  fetcher: client => (url, params) => client.get(url, {
    params,
    headers: {
      'Cache-Control': 'no-cache',
    },
  }),
})

export const useApiEcCartRequestCache = useRequest
